import type { LibraryResponses } from "@tfg/types/endpoints/library"

import { isPlatformAdmin, isSupplier } from "~/utils/permissions"

const LOGIN_PATH = "/login"
const SUPPLIER_PROFILE_PATH = "/supplier/profile"

const isAdminRoute = (pathname: string): boolean =>
  pathname === "/admin" || pathname.startsWith("/admin/")

const isBrandProfileRoute = (pathname: string): boolean =>
  pathname === "/profile" || pathname.startsWith("/profile/")

/**
 * Supplier-permission-level users must not stay on BrandAppShell routes.
 * Super admins with a supplier org keep supplier UX (redirect) except on /admin.
 * Brand /profile deep links remap to /supplier/profile (legacy reset emails).
 * Incomplete sessions (missing org) go to login — never allow-by-default.
 * Returns the path to navigate to, or null when brand shell access is allowed.
 */
export const resolveBrandShellRedirectPath = (
  user: LibraryResponses.TFGUser | null | undefined,
  getHomeRedirectUrl: (user: LibraryResponses.TFGUser) => string,
  pathname: string
): string | null => {
  if (user === null || user === undefined) {
    return null
  }

  if (user.organization === null || user.organization === undefined) {
    return LOGIN_PATH
  }

  if (!isSupplier(user)) {
    return null
  }

  if (isPlatformAdmin(user) && isAdminRoute(pathname)) {
    return null
  }

  if (isBrandProfileRoute(pathname)) {
    return SUPPLIER_PROFILE_PATH
  }

  return getHomeRedirectUrl(user)
}
